// Layer 4 (UI) — the planning hierarchy (locked comp `planning.html` A, the
// Annual tab's 4-column panel): Year 1 → Month 4 → week → day as indented
// hairline rows, each period's budget against its design (Year 1) or its
// Capacity-engine ceiling (Month 4 and shorter, D27).
// Renders PlanningTables.transform.ts `hierarchyRead`; derives nothing.

import { DowntimeCard } from '../downtime/DowntimeCard';
import type { HierarchyRow } from './PlanningTables.transform';

export function CascadeTable({
  rows,
  planEqualsBudget,
  capDecode,
  className,
}: {
  rows: readonly HierarchyRow[];
  planEqualsBudget: boolean;
  capDecode: string;
  className?: string;
}) {
  return (
    <DowntimeCard
      title="Planning hierarchy"
      meta={planEqualsBudget ? 'budget = plan' : 'budget'}
      className={className}
      aria-label="Planning hierarchy"
    >
      <div className="flex flex-col tabular-nums" data-planning-table="hierarchy">
        {rows.map((row) => (
          <div
            key={row.id}
            data-hierarchy-row={row.id}
            className="grid grid-cols-[1fr_auto] items-baseline gap-x-3 border-b border-[var(--color-divider)] py-2 last:border-b-0"
            style={{ paddingLeft: `${row.depth * 12}px` }}
          >
            <span className="whitespace-nowrap text-[13px] font-medium text-ink-primary">{row.label}</span>
            <span className="whitespace-nowrap text-right text-[13px] font-semibold text-ink-primary">{row.budget}</span>
            <span className="col-span-2 whitespace-nowrap text-right text-[11px] text-muted">{row.capLabel} {row.ceiling} · {row.basis}</span>
            <span aria-hidden="true" className="relative col-span-2 mt-1 block h-1 rounded-full bg-[var(--hairline)]">
              <span className="absolute inset-y-0 left-0 rounded-full bg-ink-primary" style={{ width: `${row.budgetPctOfCeiling}%` }} />
              <span className="absolute -bottom-1 -top-1 right-0 w-0.5 bg-ink-primary" />
            </span>
            {row.note ? <span className="col-span-2 mt-1 text-[11px] text-muted">{row.note}</span> : null}
          </div>
        ))}
      </div>
      <p className="mt-1.5 text-xs text-muted">{capDecode}</p>
    </DowntimeCard>
  );
}
